export function shoppingCart(state) {
  return state.shoppingCart;
}
